import React from 'react';
import SectionTitle from '../../../components/SectionTitle';
import AccordionBS from '../../../components/AccordionBS';
import { StyledHowTestingWorks } from './styles/StyledHowTestingWorks';

const HowTestingWorks = ({ content, bgColor }) => {
  return (
    <StyledHowTestingWorks style={{backgroundImage: 'linear-gradient(to right, #f9f9f9 0, #f9f9f9 35%, #fff 35%, #fff 100%)' }}>
      <div className="rn-section-gap">
        <div className="container">
          <div className="section-wrapper">
            <div className="section-col-1">
              <img className="solo-image" src={content.soloImage.src} alt={content.soloImage.alt} />
            </div>
            <div className="section-col-2">
              <SectionTitle {...content.sectionTitle} />
              <AccordionBS {...content.accordionBS} />
            </div>
          </div>
        </div>
      </div>
    </StyledHowTestingWorks>
  );
};

export default HowTestingWorks;
